import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {ImageEntry, Product} from '../../../../../models/product';
import {environment} from '../../../../../../../environments/environment';
import {ProductOptionsService} from '../../product-options/product-options.service';
import {ProductService} from '../../../../../services/product.service';
import {ImageLightBoxComponent} from '../main-image/image-light-box/image-light-box.component';
import {MatDialog} from '@angular/material/dialog';
import {VideoBlackBoxComponent} from '../main-image/video-black-box/video-black-box.component';

@Component({
    selector: 'app-thumbnail-images',
    templateUrl: './thumbnail-images.component.html',
    styleUrls: ['./thumbnail-images.component.css']
})
export class ThumbnailImagesComponent implements OnInit {
    @Input() product: Product;
    imageList: ImageEntry[] = [] ;

    constructor(        public productOptionService: ProductOptionsService,
                        public productService: ProductService ,  private dialog: MatDialog) {
    }

    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: true,
        lazyLoad: true,
        margin: 0,
        dots: false,
        navSpeed: 200,
        nav: true,
        navText: ["<div class='nav-btn prev-slide  p-slider-arrow-left'>" +
        "<i class='la la-chevron-circle-left'></i></div>",
            "<div class='nav-btn next-slide p-slider-arrow-right'><i class='la la-chevron-circle-right'></i></div>"],
        // navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ],
        autoHeight: true,
        autoWidth: false,
        slideBy: '4',
        responsive: {
            0: {
                items: 1
            },
            100: {
                items: 1
            },
            440: {
                items: 1
            },
            740: {
                items: 3
            },
            900: {
                items: 4
            },
            1280: {
                items: 5
            }
        }
    };


    baseImageURL = 'https://alarabiya.com.kw/pub/media/catalog/product/';

    getImageURL(i) {
       // return this.baseImageURL + '/' + this.productInfo[0].media_gallery_entries[i].file;
       //  return this.product.getImage();

        if (this.product.media_gallery_entries[0] == undefined) {

        } else {

            return environment.baseCatalogUrl + environment.baseImagePath + this.product.media_gallery_entries[i].file;
        }

    }

    openImageDialog(event , index) {
        event.preventDefault();
        const dialogRef = this.dialog.open(ImageLightBoxComponent, {
            data: {product : this.product , index: index },
            // width: '100%',
            // maxWidth: '100%'


        });

    }

    openVideoDialog(event , index){
        event.preventDefault();
        const dialogRef = this.dialog.open(VideoBlackBoxComponent, {
            data: {product : this.product , index: index },
            width: '70%',
            // maxWidth: '100%'
            panelClass : 'black-box'


        });
    }

    ngOnInit(): void {
    }

    itemSelected() {

        // this.productOptionService.EmitOptionItemSelectedEvent(this.product);
        this.productService.getProductDetailsFull(this.product.sku).subscribe(product =>{
            this.product = product;
            this.productOptionService.EmitOptionItemSelectedEvent(this.product);
        });


    }

}
